export default __webpack_public_path__ + "static/media/fourth.e9eeb0a0.gif";